import { makeContextFor } from "@me8eon/context";
import { IStorage, mapStorageImplementation } from "@me8eon/storage";
import { CryptoStore } from "@me8eon/crypto_store";


// --- Storage Implementations as Plain Objects ---

export const localStorageImplementation: IStorage = {
    type: "localStorage",
    getItem: (key: string): string | null => localStorage.getItem(key),
    setItem: (key: string, value: string): void => localStorage.setItem(key, value),
    removeItem: (key: string): void => localStorage.removeItem(key),
};

export const sessionStorageImplementation: IStorage = {
    type: "sessionStorage",
    getItem: (key: string): string | null => sessionStorage.getItem(key),
    setItem: (key: string, value: string): void => sessionStorage.setItem(key, value),
    removeItem: (key: string): void => sessionStorage.removeItem(key),
};

export const cookieStorageImplementation: IStorage = {
    type: "cookieStorage",
    getItem: (key: string): string | null => {
        const regex = new RegExp("(?:^|; )" + encodeURIComponent(key) + "=([^;]*)");
        const match = document.cookie.match(regex);
        return match ? decodeURIComponent(match[1]) : null;
    },
    setItem: (key: string, value: string): void => {document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(value)}; path=/; max-age=31536000`;},
    removeItem: (key: string): void => {document.cookie = `${encodeURIComponent(key)}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;},
};


// --- Detection Function ---
// Writes a random value to a test key, checks if it can read it back correctly, and then removes it.
export const isStorageWorking = (storage: IStorage): boolean => {
    const testKey = "__storage_test__";
    const testValue = Math.random().toString();
    try {
        storage.setItem(testKey, testValue);
        const working = storage.getItem(testKey) === testValue;
        storage.removeItem(testKey);
        return working;
    } catch (e) {
        return false;
    }
};

export const defaultCandidates: IStorage[] = [
    localStorageImplementation,
    sessionStorageImplementation,
    cookieStorageImplementation,
    mapStorageImplementation(),
];
// --- Storage Selector ---
// Returns the first working candidate (order: localStorage, sessionStorage, cookies, and finally in-memory map).
export const getWorkingStorage = (candidates: IStorage[] = defaultCandidates): IStorage => {
    for (const candidate of candidates) {
            if (isStorageWorking(candidate)) return candidate;
    }
    return mapStorageImplementation();
};


export const { use: useStorage, Provider: StorageProvider } = makeContextFor<IStorage, "storage">("storage");

export const { use: useCrytoStore, Provider: CryptoStoreProvider } = makeContextFor<CryptoStore<string>, "cryptoStore">("cryptoStore");